import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from "rxjs/Observable";


@Injectable()
export class ApiService {
    apiPrefix: string = '/est_api';

    constructor(private http: Http) {
    }

    post(url: string, data: any): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        let urlWithPrefix = this.apiPrefix + url;

        return this.http.post(urlWithPrefix, JSON.stringify(data), options)
            .map(res => res.json());
    }

    put(url: string, data: any): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        let urlWithPrefix = this.apiPrefix + url;

        return this.http.put(urlWithPrefix, JSON.stringify(data), options)
            .map(res => res.json());
    }

    get(url: string): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        let urlWithPrefix = this.apiPrefix + url;

        return this.http.get(urlWithPrefix, options).map(res => res.json());
    }

    delete(url: string): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        let urlWithPrefix = this.apiPrefix + url;

        return this.http.delete(urlWithPrefix, options).map(res => res.json());

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/api.service.ts